"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.badgeData = void 0;
exports.badgeData = {
  BackInStock: {
    value: "Back in Stock",
    backgroundColor: "var(--hmf-badge-backinstock-background-color)",
    textColor: "var(--hmf-badge-backinstock-text-color)"
  },
  ComingSoon: {
    value: "Coming Soon",
    backgroundColor: "var(--hmf-badge-comingsoon-background-color)",
    textColor: "var(--hmf-badge-comingsoon-text-color)"
  },
  CustomizeIt: {
    value: "Customize It",
    backgroundColor: "var(--hmf-badge-customizeit-background-color)",
    textColor: "var(--hmf-badge-customizeit-text-color)"
  },
  DicksExclusive: {
    value: "Only at DICK'S",
    backgroundColor: "var(--hmf-badge-dicksexclusive-background-color)",
    textColor: "var(--hmf-badge-dicksexclusive-text-color)"
  },
  Exclusive: {
    value: "Exclusive",
    backgroundColor: "var(--hmf-badge-exclusive-background-color)",
    textColor: "var(--hmf-badge-exclusive-text-color)"
  },
  GGExclusive: {
    value: "Exclusive",
    backgroundColor: "var(--hmf-badge-exclusive-background-color)",
    textColor: "var(--hmf-badge-exclusive-text-color)"
  },
  ExtendedSizes: {
    value: "Extended Sizes",
    backgroundColor: "var(--hmf-badge-extendedsizes-background-color)",
    textColor: "var(--hmf-badge-extendedsizes-text-color)"
  },
  FanShopShip: {
    value: "Ships in 24-48 Hrs",
    backgroundColor: "var(--hmf-badge-fanshopship-background-color)",
    textColor: "var(--hmf-badge-fanshopship-text-color)"
  },
  GoldAPEExclusive: {
    value: "Gold Exclusive",
    backgroundColor: "var(--hmf-badge-goldapeexclusive-background-color)",
    textColor: "var(--hmf-badge-goldapeexclusive-text-color)"
  },
  GuidePick: {
    value: "Guide Pick",
    backgroundColor: "var(--hmf-badge-guidepick-background-color)",
    textColor: "var(--hmf-badge-guidepick-text-color)"
  },
  Local: {
    value: "Local",
    backgroundColor: "var(--hmf-badge-local-background-color)",
    textColor: "var(--hmf-badge-local-text-color)"
  },
  ModelWearing: {
    value: "Model is Wearing",
    backgroundColor: "var(--hmf-badge-modelwearing-background-color)",
    textColor: "var(--hmf-badge-modelwearing-text-color)"
  },
  NewArrivals: {
    value: "New",
    backgroundColor: "var(--hmf-badge-newarrivals-background-color)",
    textColor: "var(--hmf-badge-newarrivals-text-color)"
  },
  NewColor: {
    value: "New Color",
    backgroundColor: "var(--hmf-badge-newcolor-background-color)",
    textColor: "var(--hmf-badge-newcolor-text-color)"
  },
  NikeAPEExclusive: {
    value: "DICK'S x Nike",
    backgroundColor: "var(--hmf-badge-nikeapeexclusive-background-color)",
    textColor: "var(--hmf-badge-nikeapeexclusive-text-color)"
  },
  PersonalizedItem: {
    value: "Personalized",
    backgroundColor: "var(--hmf-badge-personalizeditem-background-color)",
    textColor: "var(--hmf-badge-personalizeditem-text-color)"
  },
  ProPick: {
    value: "Pro Pick",
    backgroundColor: "var(--hmf-badge-propick-background-color)",
    textColor: "var(--hmf-badge-propick-text-color)"
  },
  RentalCapacity: {
    value: "Rental Capability",
    backgroundColor: "var(--hmf-badge-rentalcapacity-background-color)",
    textColor: "var(--hmf-badge-rentalcapacity-text-color)"
  },
  Sponsored: {
    value: "Sponsored",
    backgroundColor: "var(--hmf-badge-sponsored-background-color)",
    textColor: "var(--hmf-badge-sponsored-text-color)"
  },
  Sustainability: {
    value: "Sustainable",
    backgroundColor: "var(--hmf-badge-sustainability-background-color)",
    textColor: "var(--hmf-badge-sustainability-text-color)"
  },
  TopDeals: {
    value: "Top Deal",
    backgroundColor: "var(--hmf-badge-topdeals-background-color)",
    textColor: "var(--hmf-badge-topdeals-text-color)"
  },
  TopSeller: {
    value: "Top Seller",
    backgroundColor: "var(--hmf-badge-topseller-background-color)",
    textColor: "var(--hmf-badge-topseller-text-color)"
  },
  Used: {
    value: "Used",
    backgroundColor: "var(--hmf-badge-used-background-color)",
    textColor: "var(--hmf-badge-used-text-color)"
  },
  ViewingItem: {
    value: "Viewing Item",
    backgroundColor: "var(--hmf-badge-viewingitem-background-color)",
    textColor: "var(--hmf-badge-viewingitem-text-color)"
  },
  WideWidth: {
    value: "Extended Widths",
    backgroundColor: "var(--hmf-badge-widewidth-background-color)",
    textColor: "var(--hmf-badge-widewidth-text-color)"
  },
  WomenOwned: {
    value: "Women-Owned Brand",
    backgroundColor: "var(--hmf-badge-womenowned-background-color)",
    textColor: "var(--hmf-badge-womenowned-text-color)"
  }
};
